import { render, staticRenderFns } from "./OverviewConfirmation.vue?vue&type=template&id=45701e84&scoped=true"
import script from "./OverviewConfirmation.vue?vue&type=script&lang=ts"
export * from "./OverviewConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./OverviewConfirmation.vue?vue&type=style&index=0&id=45701e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45701e84",
  null
  
)

export default component.exports